(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["currency-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    function openModal(modal) {
      if (!modal) return;
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      var closeButton = modal.querySelector('[data-currency-modal-close]');
      if (closeButton) closeButton.focus();
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-currency-modal-trigger]');
      if (trigger) {
        openModal(document.getElementById(trigger.getAttribute('aria-controls')));
        return;
      }

      var closeButton = event.target.closest('[data-currency-modal-close]');
      if (closeButton) {
        closeModal(closeButton.closest('[data-currency-modal]'));
        return;
      }
    });

    document.addEventListener('click', function (event) {
      var modal = event.target.closest('[data-currency-modal]');
      if (modal && event.target === modal) {
        closeModal(modal);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var modal = document.querySelector('[data-currency-modal].is-active');
      if (modal) {
        closeModal(modal);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-announcement-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    function initAnnouncementBar(bar) {
      if (bar.dataset.announcementInitialized === 'true') return;
      bar.dataset.announcementInitialized = 'true';

      var messages = bar.querySelectorAll('[data-announcement-message]');
      if (messages.length < 2) return;

      var speed = Math.max(2, parseFloat(bar.dataset.announcementSpeed) || 4) * 1000;
      var index = 0;
      var paused = false;

      function show(nextIndex) {
        var current = messages[index];
        var next = messages[nextIndex];
        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        current.setAttribute('aria-hidden', 'true');
        next.classList.remove('is-leaving');
        next.classList.add('is-active');
        next.removeAttribute('aria-hidden');
        setTimeout(function () {
          current.classList.remove('is-leaving');
        }, 500);
        index = nextIndex;
      }

      bar.addEventListener('mouseenter', function () { paused = true; });
      bar.addEventListener('mouseleave', function () { paused = false; });

      setInterval(function () {
        if (paused || document.hidden) return;
        show((index + 1) % messages.length);
      }, speed);

      // Theme editor: jump to a message when its block is selected
      document.addEventListener('shopify:block:select', function (event) {
        for (var i = 0; i < messages.length; i++) {
          if (messages[i] === event.target && i !== index) show(i);
        }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-announcement-bar]').forEach(initAnnouncementBar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-desktop-megamenu"] && !Shopify.designMode) return;
  try {
    (function () {
    const headerGroup = document.querySelector('.header-group');
    if (!headerGroup) return;

    const megamenu = headerGroup.querySelector('.megamenu');
    if (!megamenu) return;

    const triggers = headerGroup.querySelectorAll('[data-megamenu-trigger]');
    const panels = megamenu.querySelectorAll('[data-megamenu-panel]');

    function showPanel(handle) {
      document.dispatchEvent(new CustomEvent('search:close'));
      headerGroup.classList.add('is-active');
      megamenu.classList.add('is-active');
      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.megamenuPanel === handle);
      });
      triggers.forEach((t) => {
        t.classList.toggle('is-active', t.dataset.megamenuTrigger === handle);
      });
    }

    function hideAll() {
      megamenu.classList.remove('is-active');
      if (!headerGroup.classList.contains('is-search-active')) {
        headerGroup.classList.remove('is-active');
      }
      triggers.forEach((t) => t.classList.remove('is-active'));
      setTimeout(() => {
        if (!megamenu.classList.contains('is-active')) {
          panels.forEach((panel) => panel.classList.remove('is-active'));
        }
      }, 300);
    }

    /* Show the matching panel when hovering a nav trigger */
    triggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => {
        showPanel(trigger.dataset.megamenuTrigger);
      });

      trigger.addEventListener('focus', () => {
        showPanel(trigger.dataset.megamenuTrigger);
      });
    });

    /* Only close when mouse leaves the entire header group */
    headerGroup.addEventListener('mouseleave', hideAll);

    /* Close on Escape */
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') hideAll();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-desktop"] && !Shopify.designMode) return;
  try {
    (function () {
    var headerGroup = document.querySelector('.header-group--transparent');
    if (!headerGroup) return;

    function syncTransparentHeaderState() {
      headerGroup.classList.toggle('is-scrolled', window.scrollY > 0);
    }

    syncTransparentHeaderState();
    window.addEventListener('scroll', syncTransparentHeaderState, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mobile-megamenu"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.mobile-nav__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var submenu = trigger.nextElementSibling;
        var chevron = trigger.querySelector('.mobile-nav__chevron');
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          trigger.setAttribute('aria-expanded', 'false');
          submenu.classList.remove('is-open');
          submenu.setAttribute('aria-hidden', 'true');
          if (chevron) chevron.classList.remove('is-open');
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          submenu.classList.add('is-open');
          submenu.setAttribute('aria-hidden', 'false');
          if (chevron) chevron.classList.add('is-open');
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mobile-search"] && !Shopify.designMode) return;
  try {
    (function () {
    var input = document.getElementById('mobile-search-input');
    if (!input) return;

    var form = input.closest('form');
    var clearBtn = document.querySelector('.mobile-search__clear');
    var resultsContainer = document.querySelector('.mobile-search__results');
    var slider = document.querySelector('.mobile-megamenu__slider');
    if (!resultsContainer) return;

    var debounceTimer = null;
    var abortController = null;
    var searchUrl = window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root + 'search'
      : '/search';

    function debounce(fn, delay) {
      return function () {
        var args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () { fn.apply(null, args); }, delay);
      };
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function showClear(show) {
      if (clearBtn) clearBtn.classList.toggle('hidden', !show);
    }

    function slideToResults() {
      if (slider) slider.classList.add('is-searching');
      showClear(true);
    }

    function slideToNav() {
      if (slider) slider.classList.remove('is-searching');
      showClear(false);
    }

    function renderSpinner() {
      resultsContainer.innerHTML =
        '<div class="flex justify-center py-4">' +
        '<svg class="animate-spin" width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="rgba(0,0,0,0.15)" stroke-width="2"/><path d="M14.5 8a6.5 6.5 0 00-6.5-6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</div>';
    }

    // Read product cards from the theme's search section so mobile matches desktop results
    function parseSectionProducts(sectionHtml) {
      var doc = new DOMParser().parseFromString(sectionHtml || '', 'text/html');
      var cards = doc.querySelectorAll('.search-aside__result a.product-card');
      var products = [];
      cards.forEach(function (card) {
        if (products.length >= 6) return;
        var texts = card.querySelectorAll('p.text-xs');
        var img = card.querySelector('.product-card__image img');
        products.push({
          url: card.getAttribute('href'),
          title: texts[0] ? texts[0].textContent.trim() : '',
          price: texts[1] ? texts[1].textContent.trim() : '',
          image: img ? img.getAttribute('src') : ''
        });
      });
      return products;
    }

    function renderResults(products) {
      var hasAny = products.length > 0;
      var html = '';

      if (!hasAny) {
        html = '<p class="p-4 text-sm font-light text-black/40">No results found</p>';
      } else {
        html = '<div class="grid grid-cols-2 gap-1">';
        products.forEach(function (item, index) {
          var imageHtml = '';
          var image = item.image;
          if (image) {
            imageHtml =
              '<div class="image product-card__image">' +
              '<img src="' + escapeHtml(image) + '" alt="" loading="lazy">' +
              '</div>';
          }

          var priceHtml = item.price ? '<p class="text-xs">' + escapeHtml(item.price) + '</p>' : '';

          html += '<a href="' + escapeHtml(item.url) + '" class="search-result-card relative bg-[#ECECEC] p-3 w-full aspect-3/4 overflow-hidden block" style="animation-delay:' + (index * 60) + 'ms">';
          html += imageHtml;
          html += '<div class="absolute bottom-0 left-0 p-3">';
          html += '<p class="text-xs text-black/50">' + escapeHtml(item.title) + '</p>';
          html += priceHtml;
          html += '</div>';
          html += '</a>';
        });
        html += '</div>';
      }

      resultsContainer.innerHTML = html;
    }

    function clearResults() {
      resultsContainer.innerHTML = '';
    }

    var performSearch = debounce(function (query) {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      renderSpinner();

      fetch(searchUrl + '?q=' + encodeURIComponent(query) + '&type=product&sections=search-aside', {
        signal: abortController.signal
      })
        .then(function (res) { return res.json(); })
        .then(function (data) { renderResults(parseSectionProducts(data['search-aside'])); })
        .catch(function (err) {
          if (err.name !== 'AbortError') clearResults();
        });
    }, 300);

    input.addEventListener('focus', function () {
      slideToResults();
    });

    input.addEventListener('input', function () {
      var query = input.value.trim();

      if (query.length < 2) {
        clearResults();
        if (abortController) abortController.abort();
        return;
      }
      performSearch(query);
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        var query = input.value.trim();

        event.preventDefault();
        slideToResults();

        if (query.length < 2) {
          clearResults();
          if (abortController) abortController.abort();
          return;
        }

        performSearch(query);
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        slideToNav();
        input.blur();

        if (slider) {
          slider.addEventListener('transitionend', function handler(e) {
            if (e.target !== slider) return;
            slider.removeEventListener('transitionend', handler);
            clearResults();
          });
        } else {
          clearResults();
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mobile"] && !Shopify.designMode) return;
  try {
    (function () {
    var headerGroup = document.querySelector('.mobile-header-group');
    if (!headerGroup) return;

    var toggle = headerGroup.querySelector('.mobile-menu-toggle');
	    var megamenu = headerGroup.querySelector('.mobile-megamenu');
	    var cartBtn = headerGroup.querySelector('[data-mobile-cart-toggle]');
	    var cartPanel = headerGroup.querySelector('.mobile-cart-panel');
	    var filterPanel = headerGroup.querySelector('.mobile-filter-panel');
	    var currencyPanel = headerGroup.querySelector('.mobile-currency-panel');

	    var iconOpen = toggle ? toggle.querySelector('.mobile-menu-toggle__open') : null;
	    var iconClose = toggle ? toggle.querySelector('.mobile-menu-toggle__close') : null;
    var cartIconOpen = cartBtn ? cartBtn.querySelector('.mobile-cart-toggle__open') : null;
    var cartIconClose = cartBtn ? cartBtn.querySelector('.mobile-cart-toggle__close') : null;

	    var isOpen = false;
	    var isCartOpen = false;
	    var isFilterOpen = false;
	    var isCurrencyOpen = false;
	    var cartFetching = false;
	    var filterFetching = false;
	    var isTransparentHeader = headerGroup.classList.contains('mobile-header-group--transparent');

	    function syncTransparentHeaderState() {
	      if (!isTransparentHeader) return;
	      headerGroup.classList.toggle('is-scrolled', window.scrollY > 0);
	    }

	    syncTransparentHeaderState();
	    window.addEventListener('scroll', syncTransparentHeaderState, { passive: true });

	    function isMobileHeaderActive() {
	      return window.matchMedia('(max-width: 767px)').matches;
	    }

	    function setCartButtonOpen(isActive) {
	      if (cartBtn) {
	        cartBtn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
	        cartBtn.setAttribute('aria-label', isActive ? cartBtn.dataset.labelClose : cartBtn.dataset.labelOpen);
	      }
	      if (cartIconOpen) cartIconOpen.classList.toggle('hidden', isActive);
	      if (cartIconClose) cartIconClose.classList.toggle('hidden', !isActive);
	    }

	    function resetCartPanel() {
	      isCartOpen = false;
	      headerGroup.classList.remove('is-cart-open', 'is-cart-closing');
	      if (cartPanel) { cartPanel.classList.remove('is-open'); cartPanel.setAttribute('aria-hidden', 'true'); }
	    }

	    function resetFilterPanel() {
	      isFilterOpen = false;
	      headerGroup.classList.remove('is-filter-open', 'is-filter-closing');
	      if (filterPanel) { filterPanel.classList.remove('is-open'); filterPanel.setAttribute('aria-hidden', 'true'); }
	    }

	    function resetCurrencyPanel() {
	      isCurrencyOpen = false;
	      headerGroup.classList.remove('is-currency-open', 'is-currency-closing');
	      if (currencyPanel) { currencyPanel.classList.remove('is-open'); currencyPanel.setAttribute('aria-hidden', 'true'); }
	    }

	    function openMenu() {
	      if (isCartOpen) resetCartPanel();
	      if (isFilterOpen) resetFilterPanel();
	      if (isCurrencyOpen) resetCurrencyPanel();
	      setCartButtonOpen(false);
	      isOpen = true;
	      headerGroup.classList.add('is-open');
      if (megamenu) { megamenu.classList.add('is-open'); megamenu.setAttribute('aria-hidden', 'false'); }
      if (toggle) { toggle.setAttribute('aria-expanded', 'true'); toggle.setAttribute('aria-label', toggle.dataset.labelClose); }
      if (iconOpen) iconOpen.classList.add('hidden');
      if (iconClose) iconClose.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    }

	    function closeMenu() {
	      isOpen = false;
      headerGroup.classList.remove('is-open');
      if (megamenu) { megamenu.classList.remove('is-open'); megamenu.setAttribute('aria-hidden', 'true'); }
      if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.setAttribute('aria-label', toggle.dataset.labelOpen); }
      if (iconOpen) iconOpen.classList.remove('hidden');
      if (iconClose) iconClose.classList.add('hidden');
      document.body.style.overflow = '';

      setTimeout(function () {
        var slider = megamenu && megamenu.querySelector('.mobile-megamenu__slider');
        if (slider) slider.classList.remove('is-searching');

        var searchInput = megamenu && megamenu.querySelector('#mobile-search-input');
        if (searchInput) searchInput.value = '';

        var clearBtn = megamenu && megamenu.querySelector('.mobile-search__clear');
        if (clearBtn) clearBtn.classList.add('hidden');

        var resultsContainer = megamenu && megamenu.querySelector('.mobile-search__results');
        if (resultsContainer) resultsContainer.innerHTML = '';
      }, 300);
    }

	    function openCart() {
	      if (isOpen) closeMenu();
	      if (isFilterOpen) resetFilterPanel();
	      if (isCurrencyOpen) resetCurrencyPanel();
	      isCartOpen = true;
	      headerGroup.classList.add('is-cart-open');
	      setCartButtonOpen(true);
	      document.body.style.overflow = 'hidden';
      if (cartPanel) {
        var hasContent = cartPanel.querySelector('.cart-aside__body');
        if (hasContent) {
          cartPanel.classList.add('is-open');
          cartPanel.setAttribute('aria-hidden', 'false');
          fetchCartContent(false);
        } else {
          cartPanel.innerHTML = '<div style="flex:1;display:flex;align-items:center;justify-content:center"><span class="cart-spinner"></span></div>';
          cartPanel.classList.add('is-open');
          cartPanel.setAttribute('aria-hidden', 'false');
          fetchCartContent(true);
        }
      }
    }

	    function closeCart() {
	      isCartOpen = false;
	      headerGroup.classList.add('is-cart-closing');
	      headerGroup.classList.remove('is-cart-open');
	      if (cartPanel) { cartPanel.classList.remove('is-open'); cartPanel.setAttribute('aria-hidden', 'true'); }
	      setCartButtonOpen(false);
	      document.body.style.overflow = '';
	      setTimeout(function () { headerGroup.classList.remove('is-cart-closing'); }, 300);
	    }

	    function openFilter() {
	      if (isOpen) closeMenu();
	      if (isCartOpen) resetCartPanel();
	      if (isCurrencyOpen) resetCurrencyPanel();
	      isFilterOpen = true;
	      headerGroup.classList.add('is-filter-open');
	      setCartButtonOpen(true);
	      document.body.style.overflow = 'hidden';
	      if (filterPanel) {
	        var hasContent = filterPanel.querySelector('.filter-aside__form');
	        if (hasContent) {
	          filterPanel.classList.add('is-open');
	          filterPanel.setAttribute('aria-hidden', 'false');
	          fetchFilterContent(false);
	        } else {
	          filterPanel.innerHTML = '<div style="flex:1;display:flex;align-items:center;justify-content:center"><span class="cart-spinner"></span></div>';
	          filterPanel.classList.add('is-open');
	          filterPanel.setAttribute('aria-hidden', 'false');
	          fetchFilterContent(true);
	        }
	      }
	    }

	    function closeFilter() {
	      isFilterOpen = false;
	      headerGroup.classList.add('is-filter-closing');
	      headerGroup.classList.remove('is-filter-open');
	      if (filterPanel) { filterPanel.classList.remove('is-open'); filterPanel.setAttribute('aria-hidden', 'true'); }
	      setCartButtonOpen(false);
	      document.body.style.overflow = '';
	      setTimeout(function () { headerGroup.classList.remove('is-filter-closing'); }, 300);
	    }

	    function openCurrency() {
	      if (isOpen) closeMenu();
	      if (isCartOpen) resetCartPanel();
	      if (isFilterOpen) resetFilterPanel();
	      isCurrencyOpen = true;
	      headerGroup.classList.add('is-currency-open');
	      setCartButtonOpen(true);
	      document.body.style.overflow = 'hidden';
	      if (currencyPanel) {
	        currencyPanel.classList.add('is-open');
	        currencyPanel.setAttribute('aria-hidden', 'false');
	      }
	    }

	    function closeCurrency() {
	      isCurrencyOpen = false;
	      headerGroup.classList.add('is-currency-closing');
	      headerGroup.classList.remove('is-currency-open');
	      if (currencyPanel) { currencyPanel.classList.remove('is-open'); currencyPanel.setAttribute('aria-hidden', 'true'); }
	      setCartButtonOpen(false);
	      document.body.style.overflow = '';
	      setTimeout(function () { headerGroup.classList.remove('is-currency-closing'); }, 300);
	    }

    function fetchCartContent(fadeInAfter) {
      if (cartFetching || !cartPanel) return;
      cartFetching = true;
      fetch('/?sections=cart-aside')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data['cart-aside']) {
            var tmp = document.createElement('div');
            tmp.innerHTML = data['cart-aside'];
            var body = tmp.querySelector('.cart-aside__body');
            var recent = tmp.querySelector('.cart-aside__recent');
            var footer = tmp.querySelector('.cart-aside__footer');
            if (fadeInAfter) {
              cartPanel.style.transition = 'none';
              cartPanel.style.opacity = '0';
            }
            cartPanel.innerHTML = '';
            if (body) cartPanel.appendChild(body.cloneNode(true));
            if (recent) cartPanel.appendChild(recent.cloneNode(true));
            if (footer) cartPanel.appendChild(footer.cloneNode(true));
            if (window.syncCartRecentlyViewedProducts) window.syncCartRecentlyViewedProducts();
            if (fadeInAfter) {
              requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                  cartPanel.style.transition = '';
                  cartPanel.style.opacity = '';
                });
              });
            }
          }
        })
	        .catch(function () {})
	        .then(function () { cartFetching = false; });
	    }

	    function fetchFilterContent(fadeInAfter) {
	      if (filterFetching || !filterPanel) return;
	      filterFetching = true;

	      var url = new URL(window.location.href);
	      url.searchParams.set('sections', 'filter-aside');

	      fetch(url.toString())
	        .then(function (r) { return r.json(); })
	        .then(function (data) {
	          if (data['filter-aside']) {
	            var tmp = document.createElement('div');
	            tmp.innerHTML = data['filter-aside'];
	            var form = tmp.querySelector('.filter-aside__form');
	            if (fadeInAfter) {
	              filterPanel.style.transition = 'none';
	              filterPanel.style.opacity = '0';
	            }
	            filterPanel.innerHTML = '';
	            if (form) filterPanel.appendChild(form.cloneNode(true));
	            if (fadeInAfter) {
	              requestAnimationFrame(function () {
	                requestAnimationFrame(function () {
	                  filterPanel.style.transition = '';
	                  filterPanel.style.opacity = '';
	                });
	              });
	            }
	          }
	        })
	        .catch(function () {})
	        .then(function () { filterFetching = false; });
	    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (isOpen) closeMenu();
        else openMenu();
      });
    }

	    if (cartBtn) {
	      cartBtn.addEventListener('click', function () {
	        if (isCurrencyOpen) {
	          closeCurrency();
	          return;
	        }
	        if (isFilterOpen) {
	          closeFilter();
	          return;
	        }
	        if (isCartOpen) closeCart();
	        else openCart();
	      });
	    }

	    document.addEventListener('click', function (e) {
	      var filterToggle = e.target.closest('[data-filter-toggle]');
	      if (!filterToggle) return;
	      if (!isMobileHeaderActive()) return;

	      e.preventDefault();
	      e.stopImmediatePropagation();
	      openFilter();
	    }, true);

	    document.addEventListener('click', function (e) {
	      var currencyToggle = e.target.closest('[data-mobile-currency-toggle]');
	      if (!currencyToggle) return;
	      if (!isMobileHeaderActive()) return;

	      e.preventDefault();
	      e.stopImmediatePropagation();
	      openCurrency();
	    }, true);

	    document.addEventListener('click', function (e) {
	      if (!e.target.closest('[data-mobile-currency-close]')) return;
	      if (!isMobileHeaderActive()) return;

	      e.preventDefault();
	      closeCurrency();
	    }, true);

    document.addEventListener('cart:refresh', function () {
      if (isCartOpen) fetchCartContent(false);
    });

	    document.addEventListener('keydown', function (e) {
	      if (e.key === 'Escape') {
	        if (isOpen) closeMenu();
	        if (isCartOpen) closeCart();
	        if (isFilterOpen) closeFilter();
	        if (isCurrencyOpen) closeCurrency();
	      }
	    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.image').forEach(function (wrapper) {
    var img = wrapper.querySelector('.image__img');
    if (!img) return;
    function onLoad() {
      wrapper.classList.add('image--loaded');
    }
    if (img.complete && img.naturalWidth > 0) {
      onLoad();
    } else {
      img.addEventListener('load', onLoad);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    window.initProductCards = function (root) {
    root = root || document;

    // Product Card Carousel
    root.querySelectorAll('.product-card').forEach(function (card) {
      if (card.dataset.productCardInitialized === 'true') return;
      card.dataset.productCardInitialized = 'true';

      var images = JSON.parse(card.dataset.images || '[]');
      var container = card.querySelector('.product-card__image');
      var img = container && container.querySelector('img');

      if (img) img.classList.add('product-card__main-img');

      // Preload non-primary images on first hover, then remove the listener
      card.addEventListener('mouseenter', function preload() {
        card.removeEventListener('mouseenter', preload);
        for (var i = 1; i < images.length; i++) {
          var link = document.createElement('link');
          link.rel = 'preload';
          link.as = 'image';
          link.href = images[i];
          document.head.appendChild(link);
        }
      });

      // Single-image cards need no carousel logic
      if (!container || images.length <= 1) return;

      var currentIndex = 0;
      var pendingReset = false;
      var isHovering = false;
      var pendingHover = false;
      var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      // Hover image: preload the second image once the card is near the viewport
      if (canHover) {
        var preloadHoverImage = function () {
          var preloadImg = new Image();
          preloadImg.src = images[1];
        };
        if ('IntersectionObserver' in window) {
          var hoverObserver = new IntersectionObserver(function (entries) {
            if (!entries[0].isIntersecting) return;
            hoverObserver.disconnect();
            preloadHoverImage();
          }, { rootMargin: '200px' });
          hoverObserver.observe(card);
        } else {
          preloadHoverImage();
        }
      }

      // Hover image: fade the second image in over the main image
      function showHoverImage() {
        if (!canHover || !isHovering || currentIndex !== 0) return;
        if (container.classList.contains('animating')) return;
        currentIndex = 1;
        transition(images[1], { opacity: '0' }, {}, false);
      }

      // Swap the current img element with a new one, applying enter/exit transforms or fades.
      // `entering` styles are applied to the incoming image before it animates to a neutral state.
      // `exiting` styles are applied to the outgoing image as it leaves.
      function transition(src, enteringStyles, exitingStyles, isMain) {
        if (container.classList.contains('animating')) return;
        container.classList.add('animating');

        var oldImg = img;
        var newImg = document.createElement('img');
        newImg.src = src;
        newImg.style.cssText =
          'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center;';

        // Apply pre-transition state to incoming image
        Object.assign(newImg.style, enteringStyles);
        container.appendChild(newImg);

        // Double rAF ensures the browser has painted the initial state before animating
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            var tx = 'transition:transform 0.4s ease, opacity 0.4s ease';
            oldImg.style.cssText += ';' + tx;
            newImg.style.cssText += ';' + tx;

            // Animate both images to their final states
            Object.assign(oldImg.style, exitingStyles);
            newImg.style.transform = 'translateX(0)';
            newImg.style.opacity = '1';

            newImg.addEventListener('transitionend', function onEnd() {
              newImg.removeEventListener('transitionend', onEnd);
              oldImg.remove();
              // Clean up inline transition styles from the settled image
              newImg.style.transition = '';
              newImg.style.transform = '';
              newImg.style.opacity = '';
              if (isMain) newImg.classList.add('product-card__main-img');
              img = newImg;
              container.classList.remove('animating');
              if (pendingReset && currentIndex !== 0) {
                resetToMain();
              } else if (pendingHover) {
                pendingHover = false;
                showHoverImage();
              }
            });
          });
        });
      }

      function resetToMain() {
        pendingReset = false;
        currentIndex = 0;
        transition(images[0], { opacity: '0' }, { opacity: '0' }, true);
      }

      function navigate(direction, e) {
        e.preventDefault();
        e.stopPropagation();
        currentIndex = (currentIndex + direction + images.length) % images.length;
        var entering = { transform: direction > 0 ? 'translateX(100%)' : 'translateX(-100%)' };
        var exiting = { transform: direction > 0 ? 'translateX(-100%)' : 'translateX(100%)' };
        transition(images[currentIndex], entering, exiting, currentIndex === 0);
      }

      // Attach carousel button listeners
      var prev = card.querySelector('.product-card__prev');
      var next = card.querySelector('.product-card__next');
      if (prev) {
        prev.addEventListener('click', function (e) {
          navigate(-1, e);
        });
        prev.addEventListener('mousedown', function (e) {
          e.preventDefault();
        });
      }
      if (next) {
        next.addEventListener('click', function (e) {
          navigate(1, e);
        });
        next.addEventListener('mousedown', function (e) {
          e.preventDefault();
        });
      }

      // On mouse enter, show the second image
      card.addEventListener('mouseenter', function () {
        isHovering = true;
        if (container.classList.contains('animating')) {
          pendingHover = true;
          return;
        }
        showHoverImage();
      });

      // On mouse leave, animate back to the primary image if we've navigated away
      card.addEventListener('mouseleave', function () {
        isHovering = false;
        pendingHover = false;
        if (currentIndex === 0) return;
        if (container.classList.contains('animating')) {
          pendingReset = true;
          return;
        }
        resetToMain();
      });
    });

    // Add to Cart
    root.querySelectorAll('.product-card__add-btn').forEach(function (btn) {
      if (btn.dataset.productCardAddInitialized === 'true') return;
      btn.dataset.productCardAddInitialized = 'true';

      function setLoading(isLoading) {
        btn.classList.toggle('is-loading', isLoading);
        btn.disabled = isLoading;
        btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      }

      document.addEventListener('cart:open:error', function () {
        setLoading(false);
      });

      document.addEventListener('cart:opened', function () {
        setLoading(false);
      });

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = btn.dataset.variantId;
        if (!variantId || btn.classList.contains('is-loading')) return;
        setLoading(true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error('Cart add failed');
            return r.json();
          })
          .then(function (item) {
            document.dispatchEvent(
              new CustomEvent('cart:open', {
                detail: {
                  item: {
                    key: item.key,
                    variantId: String(item.variant_id || variantId),
                    title: item.product_title || btn.dataset.cartTitle || '',
                    url: item.url || btn.dataset.cartUrl || '#',
                    image: item.image || btn.dataset.cartImage || '',
                    price: btn.dataset.cartPrice || '',
                    quantity: 1,
                  },
                  refresh: true,
                  delay: 350,
                },
              })
            );
          })
          .catch(function () {
            document.dispatchEvent(new CustomEvent('cart:open', { detail: { refresh: true } }));
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    window.initProductCards(document);
  });
  } catch(e) { console.error(e); }
})();

})();
